import React from 'react';

import { IconButton } from 'packages/common-frontend/components/IconButton';
import { FiLock, FiUnlock } from 'react-icons/fi';

type PartiesLockButtonProps = {
  setArePartiesLocked: React.Dispatch<React.SetStateAction<boolean>>;
  arePartiesLocked: boolean;
};
export const PartiesLockButton = ({
  setArePartiesLocked,
  arePartiesLocked,
}: PartiesLockButtonProps) => {
  return (
    <IconButton
      onClick={() => setArePartiesLocked(!arePartiesLocked)}
      icon={arePartiesLocked ? <FiLock /> : <FiUnlock />}
      ariaLabel={arePartiesLocked ? 'Parties Locked' : 'Parties Unlocked'}
      colorScheme={arePartiesLocked ? 'red' : 'green'}
      label={arePartiesLocked ? 'Parties Locked' : 'Parties Unlocked'}
    />
  );
};
